
<div class="screen-booking">
  <div class="popup-aside-plain">
    <div class="popup-takeResa">
      <div style="text-align:center">{{ getAllInfos.restoName }}</div>
      <div style="font-weight:100; font-size:14px">
        <div style="text-align:center">{{ getAllInfos.restoAdresse }}</div>
        <div style="text-align:center"><a :href="'tel:' + getAllInfos.restoTel">{{ getAllInfos.restoTel }}</a></div>
      </div>
    </div>
    <div class="success-container" v-loading="loading">
      <el-row :class="'black-inputs'">
        <el-col :span="18" :offset="3">
          <br>
          <div>
            <p v-if="getAllInfos.resaConfirmMessage">
              {{ getAllInfos.resaConfirmMessage }}
            </p>
            <p v-else>
              Bravo ! <br />Votre réservation est acceptée par le restaurateur.
            </p>
          </div>
          <br>
          <div v-if="currentResa">
            Nous vous attendons donc le {{ currentResa.date.labelDay }} {{ currentResa.date.day }}
            {{ currentResa.date.labelMonth }} {{ currentResa.date.year }} à {{ currentResa.hour }} pour
            {{ currentResa.couverts }} personne(s)
            et un prepaiement de {{ currentResa.total }} € a été fait.
          </div>
          <br>
          <div v-if="getAllInfos.resaAutoAcceptPrepaiementMessage"
            v-html="renderMarkdown(getAllInfos.resaAutoAcceptPrepaiementMessage)">
          </div>
          <br>
          <div>Merci pour votre réservation. </div>
          <br>
          <div></div>
        </el-col>
      </el-row>
    </div>
  </div>
</div>
